import { render, staticRenderFns } from "./PartnerAddModal.vue?vue&type=template&id=15b92c4e&"
import script from "./PartnerAddModal.vue?vue&type=script&lang=js&"
export * from "./PartnerAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports